// extracted by mini-css-extract-plugin
module.exports = {"contactSalesButton":"CancelledSubscription_contactSalesButton__zo1g8","userCard":"CancelledSubscription_userCard__myt0B"};